module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-nav grid",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "mobile-nav--header",
    class: [_vm.scrollLockIosFixClasses],
    style: (_vm.scrollLockStyles)
  }, [_c('div', {
    staticClass: "mobile-nav--wrapper",
    class: [_vm.isPhone ? 'mobile-nav--wrapper__is-phone' : '']
  }, [_c('div', {
    staticClass: "mobile-nav--row"
  }, [_c('div', {
    staticClass: "mobile-nav--col"
  }, [_c('button', {
    staticClass: "mobile-nav--menu-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.requestMobileNav($event)
      }
    }
  }, [_c('div', {
    staticClass: "mobile-nav--icon mobile-nav-btn",
    class: _vm.mobileNavBtnClasses
  }, _vm._l((3), function(n) {
    return _c('span', {
      staticClass: "mobile-nav-btn--bar"
    })
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "mobile-nav--logo-btn",
    attrs: {
      "to": _vm.homeTree.path,
      "title": _vm.homeTree.label
    }
  }, [_c('img', {
    staticClass: "mobile-nav--logo",
    attrs: {
      "src": _vm._f("static")('img/sib_logo.svg')
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav--list",
    class: [_vm.scrollLockIosFixClasses]
  }, [_c('transition', {
    attrs: {
      "name": "trs-toggle-mobile-nav"
    },
    on: {
      "enter": _vm.onScrollLockEnterHook,
      "afterLeave": _vm.onScrollLockAfterLeaveHook
    }
  }, [(_vm.mobileNavigation.isOpen) ? _c('cmp-mobile-nav-list', {
    staticClass: "mobile-nav--list-root",
    attrs: {
      "menu": _vm.homeTree.children,
      "meta": _vm.meta
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3cf5f26d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf5f26d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/mobile-nav/index.vue
// module id = 533
// module chunks = 7